import Vue from 'vue'
export const EventBus = new Vue()

export const ReloadList = ()=> EventBus.$emit('reload-list')



// WEBPACK FOOTER //
// ./src/eventBus.js